module.exports = "<div class=\"hero-body\">\r\n    <div class=\"container\">\r\n        <h1 class=\"title\">{{title}}</h1>\r\n        <h2 class=\"subtitle\">{{subtitle}}</h2>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-general/components/hero/hero-body/hero-body.component.html
// module id = ./src/app/ui-general/components/hero/hero-body/hero-body.component.html
// module chunks = main